// Dashboard
export const DASHBOARD_ANALYTICS_VALID_ACCOUNT_TYPE = 'ALL';
export const DASHBOARD_POLICYHOLDER_TABLE_TITLE = 'Policyholders';
export const DASHBOARD_POLICYHOLDER_TABLE_FF =
	'property.ui.home.policyholder.list';

// Claims Card
export const CLAIMS_CARD_TITLE = 'Open Claims';
export const CLAIMS_CARD_PENDING_CLAIMS_TITLE = 'pending claims';
export const CLAIMS_CARD_OPEN_SUBCLAIMS_TITLE = 'open subclaims';

// Invoice Card
export const INVOICE_CARD_TITLE = 'Total Invoices';
export const INVOICE_CARD_SETTLED_TITLE = 'settled';
export const INVOICE_CARD_PAST_DUE_TITLE = 'past due';

// Policy Card
export const POLICY_CARD_TITLE = 'On-risk Policies';
export const POLICY_CARD_PRE_ISSUED_TITLE = 'pre-issued';
export const POLICY_CARD_EXPIRED_TITLE = 'expired';

// Failed Metrics Card
export const FAILED_METRICS_CARD_SUBTITLE =
	'Error loading analytics. Refresh to try again.';

// Read Only Metrics Card
export const READ_ONLY_METRICS_CARD_SUBTITLE =
	'This user does not have permission to view tenant analytics.';

// Policyholder Table
// Autofill Button
export const AUTOFILL_ALWAYS_ON_FF = 'property.ui.autofill.button.enabled';
